import { render } from "./StatisticCard.vue?vue&type=template&id=0d0b47b4"
import script from "./StatisticCard.vue?vue&type=script&lang=js"
export * from "./StatisticCard.vue?vue&type=script&lang=js"

import "./StatisticCard.vue?vue&type=style&index=0&id=0d0b47b4&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QItem,QItemSection,QItemLabel,QCardSection});
